import { gql } from "@apollo/client";

export const SCAN_STOCK_UNIT = gql`
  mutation ScanStockUnitMutation($input: ScanStockUnitInput!) {
    scanStockUnit(input: $input) {
      ok
      error
      stockUnit {
        id
        batchNumber
        quantity
        exitedAt
        product {
          id
          name
        }
        warehouse {
          id
          name
        }
      }
    }
  }
`;

export const STOCK_SCAN = gql`
  query StockScanQuery($id: Int!) {
    stockScan(id: $id) {
      ok
      error
      result {
        id
        action
        lat
        lng
        createdAt
        stockUnit {
          id
          batchNumber
        }
        scannedBy {
          id
          firstname
          lastname
        }
      }
    }
  }
`;

export const STOCK_SCANS = gql`
  query StockScansQuery($where: StockScansFiltersInput!) {
    stockScans(where: $where) {
      ok
      error
      total
      results {
        id
        action
        createdAt
        scannedBy {
          id
          firstname
          lastname
        }
      }
    }
  }
`;
